import { http } from 'wagmi';
import { bsc } from 'wagmi/chains';
import { getDefaultConfig } from '@rainbow-me/rainbowkit';

declare global {
  interface Window {
    ethereum?: any;
  }
}

export const projectId = '7f0e3b311233367feafeeff44465cd33';

// Configure Wagmi with RainbowKit
export const config = getDefaultConfig({
  appName: 'Hotel NFT Collection',
  projectId,
  chains: [bsc],
  transports: {
    [bsc.id]: http('https://bsc-dataseed.binance.org/'),
  },
  ssr: true,
});

// Log the config for debugging
console.log('Wagmi config initialized with BSC chain');
